export const stepIndicatorWrapperStyles = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	transform: 'translateY(10px)',
};

export const stepIndicatorCompletedStyles = {
	width: '10px',
	height: '10px',
	position: 'relative',
};

export const stepIndicatorCheckIconStyles = { width: '10px', height: '10px', position: 'absolute' };

export const stepIndicatorCurrentStyles = {
	width: '10px',
	height: '10px',
	borderRadius: '100%',
	backgroundColor: 'primary.main',
};

export const stepIndicatorUpcomingStyles = {
	width: '10px',
	height: '10px',
	borderRadius: '100%',
	backgroundColor: 'neutrals.disabled',
};

export const stepIndicatorLineStyles = {
	flexGrow: 1,
	width: '2px',
	backgroundColor: 'neutrals.disabled',
	margin: '5px 0',
};
